import axios from 'axios';

const API_URL = '/api/lessons/';

// Get lessons by course ID
const getLessonsByCourse = async (courseId) => {
  const response = await axios.get(`/api/courses/${courseId}/lessons`);
  return response.data;
};

// Get lesson by ID
const getLessonById = async (lessonId) => {
  const response = await axios.get(API_URL + lessonId);
  return response.data;
};

// Mark lesson as completed
const markLessonCompleted = async (lessonId, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.post(`/api/progress/lessons/${lessonId}/complete`, {}, config);
  return response.data;
};

const lessonService = {
  getLessonsByCourse,
  getLessonById,
  markLessonCompleted,
};

export default lessonService;